import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { VERSION } from '@angular/core';


@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet><ngx-spinner size = "medium"></ngx-spinner></router-outlet>'
})
export class AppComponent implements OnInit {
  constructor(private router: Router) { }

  ngOnInit() {
console.log("version " ,VERSION.full);  

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
